import React, { useEffect, useState } from 'react';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboPerfiles from './combo';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';
//import { ComboSelectablePerfiles } from './combo_new';


export const ComboPerfilesContainer = (props:any) => {

	const api = new UsuariosAdapter();
	const{currentUser}=props;
	const { exceptionError, resultError } = useNotifications();
  	let [perfiles, setPerfiles] = useState<any>([])
	let result: any;

  useEffect(()=>{
    getPerfiles();
  },[])

	const getPerfiles = async () => {
		try {
			result = await api.ListarPerfiles();
			if(result.data && result.data!=="")
			{
				const _dataFilter:any = currentUser.perfil!==PERFIL_ADMIN?result.data.filter((f:any)=> f.id!==PERFIL_ADMIN):result.data;
				setPerfiles([ ..._dataFilter ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <ComboPerfiles {...props} data={perfiles}/>
};

export default ComboPerfilesContainer;